
import ProductsPage from '~/components/ProductsPage'
export default {
  auth: false,
  components: {
    ProductsPage
  },
  head: {
    title: 'Productos - Electrónica Poderosa',
    meta: [
      { hid: 'description', name: 'description', content: 'Electrónica Poderosa Productos' }
    ]
  }
}
